import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { AuthModule } from "./auth.module";
import { AuthorizationRequestConfigurationService } from '../configuration/auth/authorization-request-configuration/authorization-request-configuration.service';
import { ClientConfigurationService } from '../configuration/auth/client/client-configuration.service';
import { AuthorityService } from './authority/authority.service';

@Injectable({
  providedIn: AuthModule
})
export class AuthorizationRequestService {
  get response_type() {
    return "code";
  }

  get redirect_uri() {
    return this.configuration.redirect_uri;
  }

  get clientId() {
    return this.clientConfiguration.clientId;
  }

  get path() {
    return this.configuration.path;
  }

  get scope() {
    return this.configuration.scope;
  }

  get clientConfiguration() {
    return this.clientConfigurationService.configuration;
  }

  get configuration() {
    return this.authorizationRequestConfigurationService.configuration;
  }

  constructor(
    private authorizationRequestConfigurationService: AuthorizationRequestConfigurationService,
    private clientConfigurationService: ClientConfigurationService,
    private authorityService: AuthorityService
  ) {}

  createAuthorizationRequestUrl() {
    const params = this.createParams();

    return this.createAuthorizationRequestUrlWithParams(params);
  }

  createAuthorizationRequestUrlWithParams(params) {
    return this.authorityService.createResourceUrlWithParams(this.path, params, true);
  }

  createHttpParamsOption(params) {
    return {
      fromObject: params
    };
  }

  createParams() {
    const params: any = {
      response_type: this.response_type,
      client_id: this.clientId,
      redirect_uri: this.redirect_uri,
    };
    if (this.scope) {
      params.scope = this.scope;
    }
    return new HttpParams(this.createHttpParamsOption(params));
  }
}
